import {Group, rem, Stack, Text} from "@mantine/core";
import {createContentStyles} from "../../../theme/useContentStyles";
import {InsightContainer, InsightContainerProps} from "../InsightContainer/InsightContainer";
import {useTranslation} from "react-i18next";
import {PropsWithChildren} from "react";

const useStyles = createContentStyles((theme) => ({
  value: {
    fontSize: rem(24),
    fontWeight: 700,
    lineHeight: 1,
  },
}));

export type InsightEmptyProps = Omit<InsightContainerProps, 'children' | 'title'> & {
  title?: string
}

export const InsightEmpty = (props: PropsWithChildren<InsightEmptyProps>) => {
  const {t} = useTranslation(["common"])

  const {
    title = t<string>("common.shared.nodata", "No Data"),
    children,
    ...rest
  } = props

  const {classes} = useStyles();

  return (
    <InsightContainer {...rest} title={title}>
      <Stack>
        <Group align="flex-end" spacing="xs" mt={25}>
          <Text className={classes.value}>
            {t("common.shared.notapplicable", "N/A")}
          </Text>
        </Group>
        {children}
      </Stack>
    </InsightContainer>
  );
}
